import React from 'react';
import { Stack, StackProps } from 'components/stack';
import { Button, Divider, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useIsBelowMd } from 'hooks/use-is-below-md';
import { useTranslate } from 'hooks/use-translate';
import clsx from 'clsx';
import style from './index.module.scss';

interface Props extends Omit<StackProps, 'title'> {
  title?: React.ReactNode;
  onClose?: () => void;
  disabled?: boolean;
}

export const EditorTitle: React.FC<React.PropsWithChildren<Props>> = ({
  onClose,
  title,
  disabled,
  children,
  ...rest
}) => {
  const { t } = useTranslate();
  // PD-09: below md the close is an icon (its label stays the accessible name)
  const isBelowMd = useIsBelowMd();
  return (
    <Stack
      spacing={2}
      style={{ flexGrow: 1 }}
      {...rest}
      className={clsx(style.root, rest.className)}
      sx={[
        {
          alignItems: 'center',
        },
        ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
      ]}
    >
      {title !== undefined && (
        <Typography variant="h1" className={style.title} style={{ flexGrow: 1 }}>
          {title}
        </Typography>
      )}

      {children}
      {onClose && (
        <Button
          className={style.close}
          style={{ minWidth: 120, minHeight: 30 }}
          onClick={onClose}
          variant="contained"
          color="secondary"
          size={'small'}
          disabled={Boolean(disabled)}
          startIcon={isBelowMd ? <CloseIcon /> : undefined}
        >
          {t('close')}
        </Button>
      )}
      <Divider className={style.divider} orientation={'vertical'} flexItem style={{ height: 64 }} />
    </Stack>
  );
};
